export class CreateProductionRunOrderIds {

    /** What the run is made from; the same address creates a run from pickups or a shipment, so the body says which */
    public readonly source: string = 'order-ids';

    public name: string = '';

    /** The Excel spreadsheet of the order IDs, in its first column with no header row, as the base64 of the file */
    public orderIdsFile: string = '';

}
